<template>
  <nav
      class="navbar navbar-expand-md bg-nav-red sticky-top border-bottom"
      data-bs-theme="dark"
  >
    <div class="container">
      <a class="navbar-brand d-md-none" href="#">
        <svg class="bi" width="24" height="24" aria-hidden="true">
          <use xlink:href="#aperture"></use>
        </svg>
        Dart Club Wisła
      </a>
      <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvas"
          aria-controls="offcanvas"
          aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
          class="offcanvas offcanvas-end"
          tabindex="-1"
          id="offcanvas"
          aria-labelledby="offcanvasLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasLabel">Dart Club Wisła</h5>
          <button
              type="button"
              class="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <ul class="navbar-nav flex-grow-1 justify-content-between">
            <li class="nav-item logo-list-item mini-logo" :class="{ 'd-none': isStartPage }">
              <router-link to="/" class="nav-link position-absolute">
                <img width="120" height="120" alt="Dart Club Wisła" src="../../assets/logo_s.png" class="img-fluid logo-img">
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/" class="nav-link"><font-awesome-icon icon="home"/> Start</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/stanowiska" class="nav-link">Stanowiska</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/rezerwacje" class="nav-link">Rezerwacje</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Menu</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">O nas</a>
            </li>
            <li class="nav-item"><a class="nav-link" href="#">Imprezy firmowe</a></li>
            <li class="nav-item"><a class="nav-link" href="#">Kontakt</a></li>
            <li v-if="!authStore.user" class="nav-item border-danger-subtle">
              <a  href="#" class="nav-link" @click.prevent="showLoginModal = true">
                <font-awesome-icon icon="fa-regular fa-circle-user" /> Zaloguj
              </a>
            </li>
            <li v-else class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <font-awesome-icon icon="fa-regular fa-circle-user" /> Konto
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <router-link to="/user/profile" class="dropdown-item"><font-awesome-icon icon="fa-solid fa-id-card" /> Moje dane</router-link>
                </li>
                <li v-if="authStore.user && authStore.user.roles.some(role => role.name === 'admin')">
                  <router-link to="/admin" class="dropdown-item"><font-awesome-icon icon="fa-solid fa-user-shield" /> Admin</router-link>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="handleLogout"><font-awesome-icon icon="fa-solid fa-right-from-bracket" /> Wyloguj</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <LoginPage v-if="showLoginModal" @close="showLoginModal = false" />
  <FullPageAlert
      v-if="errorAlert.show"
      :title="errorAlert.title"
      :message="errorAlert.message"
      @close="errorAlert.show = false"
  />
</template>


<script>
import LoginPage from "@/components/user/LoginPage.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { useAuthStore } from "@/stores/auth";
import { fetchWrapper } from "@/wrappers/api/fetchWrapper";
import FullPageAlert from "@/components/notifications/FullPageAlert.vue";

export default {
  name: 'TopMenu',
  components: {
    FullPageAlert,
    FontAwesomeIcon,
    LoginPage
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  computed: {
    isStartPage() {
      return this.$route.path === '/';
    }
  },
  data() {
    return {
      showLoginModal: false,
      errorAlert: {
        show: false,
        title: '',
        message: ''
      }
    }
  },
  methods: {
    async handleLogout() {
      try {
        await fetchWrapper.post('/logout');
        this.authStore.logout();
        this.$router.push('/');
        this.errorAlert = {
          show: true,
          message: "Poprawnie wylogowano!",
          title: "System"
        }
      } catch (error) {
        // Even if the server call fails, we usually want to clear local state
        this.authStore.logout();
        this.$router.push('/');
      }
    }
  }
}
</script>


<style scoped>
  .bg-nav-red{
    background-color: rgb(121, 19, 19);
  }

  .logo-list-item {
    margin-top: 35px;
    width: 120px;
    transition: all 0.3s ease;
  }

  .logo-img {
    margin-top: -3rem; /* equivalent to mt-n5 */
    transition: all 0.3s ease;
  }

  .mini-logo {
    width: 40px;
    margin-top: 0;
  }

  .mini-logo .logo-img {
    width: 40px;
    height: 40px;
    margin-top: -8px;
  }

  .nav-link {
    //font-family: "Bebas Neue", sans-serif;
    //font-size: 20px;
    //text-shadow: #272727 0px 0px 8px;

    font-family: "Cinzel Decorative", serif;
    font-weight: 600;
    font-style: normal;
    text-shadow: none;
  }

  .nav-link.router-link-active{
    color: rgb(255, 255, 255);
    text-shadow: #323232 0px 6px 10px;
  }
</style>